import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SmService } from '../../../pages/sm/services/sm.service';
import { SmDataService } from '../../../pages/sm/services/sm-data.service';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';

@Component({
  selector: 'app-complete-trip-modal',
  templateUrl: './complete-trip-modal.component.html',
  styleUrls: ['./complete-trip-modal.component.css'],
})
export class CompleteTripModalComponent implements OnInit {
  @Input() lookup: any;
  @Input() isCollectSignature: any;
  @Input() currentTrip: any;
  @Input() clockStatus: any;
  portalSettings: any;
  formData: { [key: string]: any };
  closeCount = 0;
  stopCompleteTrip = false;
  closeOutMissCompleteForm = false;
  missingRequireForm: any;
  SMHideReturnTrip = false;
  closeOutMissingCallType = false;
  scopeDetails: any;
  RequiredTripNotes: any;
  missingCallType: any;
  alertCall: any;
  alertForm: any;
  headerText: any;
  SMEnablePaymentCollection: any;
  SMHideAttachmentOnComplete: any;

  constructor(
    private ngbActiveModal: NgbActiveModal,
    private smService: SmService,
    public smDataService: SmDataService,
    portalSettingsService: PortalSettingsService
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit() {
    this.formData = {};
    this.stopCompleteTrip = false;
    this.formData.loadAttachData = false;
    this.formData.closeReturnTripRequired = false;
    this.formData.collectPayment = false;
    this.formData.bypassAttach = false;
    this.SMHideAttachmentOnComplete = this.portalSettings.SMHideAttachmentOnComplete.ConfigValue;
    if (this.SMHideAttachmentOnComplete) {
      this.formData.bypassAttach = true;
    }
    this.headerText = 'WO ' + this.currentTrip.WorkOrder + ' - ' + (this.isCollectSignature ? 'Collect Signature' : 'Trip Completion');
    this.SMEnablePaymentCollection = this.portalSettings.SMEnablePaymentCollection.ConfigValue == '1';

    this.smService.getWorkOrderScopes('?sMWorkOrderID=' + this.currentTrip.SMWorkOrderID).then((response: any) => {
      this.scopeDetails = response;
    });

    if (this.isCollectSignature == false) {
      this.smService.getSettingsBySMCo(this.currentTrip.SMCo).then((response: any) => {
        this.SMHideReturnTrip = response[0].TripCloseSetting == 'D';
        this.RequiredTripNotes = response[0].RequiredTripNotes;
      });
    }

    if (this.clockStatus?.ClockAction) {
      if (
        this.currentTrip.SMTripID == this.clockStatus.SMTripID &&
        this.isCollectSignature == false &&
        (this.portalSettings.SMDaysFromTripClosedToShowWorkOrder.ConfigValue == 0 ||
          this.portalSettings.SMDaysFromTripClosedToShowWorkOrder.ConfigValue == null)
      )
        this.stopCompleteTrip = true;
    }

    this.currentTrip.ScopeDataDisplay.forEach((val, key) => {
      val.IsClose = false;
      if (!this.smDataService.currentOnline && val.SMWorkOrderScopeID == this.smDataService.currentWorkOrderScopeData.SMWorkOrderScopeID) {
        val.IsClose = true;
        this.closeCount++;
        this.continueClicked();
      }
    });
  }

  closeRequireUpdate() {
    this.formData.closeReturnTripReason = null;
    this.formData.closeNotes = null;
  }

  previewCompleteTrip() {
    let tempScopes = '';
    let tempUnique = '';

    this.currentTrip.ScopeDataDisplay.forEach((val, key) => {
      if (val.IsClose == true) {
        tempScopes += val.SMWorkOrderScopeID + ',';
        tempUnique += val.UniqueAttchID != null ? val.UniqueAttchID + ',' : ',';
      }
    });
    window.open(
      '/SM/PreviewCompleteTrip?sMTripID=' +
        this.currentTrip.SMTripID +
        '&sMWorkOrderID=' +
        this.currentTrip.SMWorkOrderID +
        '&scopes=' +
        tempScopes +
        '&unique=' +
        tempUnique +
        '&sMCO=' +
        this.currentTrip.SMCo +
        '&filename=' +
        this.currentTrip.WorkOrder +
        '_' +
        this.currentTrip.TripDescription +
        '_Completion',
      '_blank'
    );
  }

  checkAll() {
    var count = 0;

    this.currentTrip.ScopeDataDisplay.forEach((val, key) => {
      val.IsClose = this.formData.allCheck;
      count++;
    });
    this.closeCount = this.formData.allCheck ? count : 0;
  }

  updateCheck(IsClose: boolean) {
    IsClose ? this.closeCount++ : this.closeCount--;
    this.formData.allCheck = this.closeCount == this.currentTrip.ScopeDataDisplay.length;
  }

  hideAttachmentChange() {
    this.formData.loadAttachData = false;
  }

  continueClicked() {
    this.closeOutMissCompleteForm = false;
    this.closeOutMissingCallType = false;

    var tempClose = [];
    var tempCloseInt = [];
    var tempCloseExcludeForInvoice = '';
    this.missingCallType = '';

    this.currentTrip.ScopeDataDisplay.forEach((scope: any) => {
      if (scope.IsClose == true) {
        tempClose.push(scope);
        tempCloseInt.push(scope.SMWorkOrderScopeID);

        if (this.smDataService.SMCallTypeRequire) {
          this.scopeDetails.forEach((scopeDetail: any) => {
            if (scopeDetail.SMWorkOrderScopeID == scope.SMWorkOrderScopeID && scopeDetail.CallType == null) {
              this.closeOutMissingCallType = true;
              this.missingCallType += scopeDetail.Scope + ',';
            }
          });
        }
      } else {
        tempCloseExcludeForInvoice += scope.SMWorkOrderScopeID + ',';
      }
    });

    if (this.closeOutMissingCallType) {
      this.alertCall = 'The following call types are required to be finished prior to completing the trip:';
    }

    if (this.isCollectSignature) {
      this.ngbActiveModal.close({
        closeList: tempClose,
        justComplete: false,
        loadAttachData: this.formData.loadAttachData,
        bypassAttach: this.formData.bypassAttach,
      });
    } else {
      if (!this.closeOutMissingCallType) {
        this.smService.getFormsPerScopeMulti(tempCloseInt, this.currentTrip.SMTripID).then((response: any) => {
          var templateList = response.data;
          this.missingRequireForm = [];
          if (templateList != null) {
            templateList.forEach((val, key) => {
              //#513672 - Required Fields of the form need to be completed before completing the trip
              if (val.IsMissingRequiredFields) {
                this.closeOutMissCompleteForm = true;
                this.missingRequireForm.push(val);
              }
            });
          }
          if (this.closeOutMissCompleteForm) {
            this.alertForm = 'The following forms are required to be finished prior to completing the trip:';
          } else {
            this.smDataService.isReadyToCompleteSelected = false;
            if (this.closeCount == 0) {
              this.smService
                .completeTrip({
                  sMTripID: this.currentTrip.SMTripID,
                  sMWorkOrderID: this.currentTrip.SMWorkOrderID,
                  revisitRequired: this.formData.closeReturnTripRequired,
                  revisitReason: this.formData.closeReturnTripReason,
                  revisitNotes: this.formData.closeNotes,
                  justComplete: true,
                  justSendEmail: false,
                })
                .then((response: any) => {
                  this.ngbActiveModal.close({ success: response, justComplete: true });
                });
            } else {
              this.ngbActiveModal.close({
                closeList: tempClose,
                revisitRequired: this.formData.closeReturnTripRequired,
                revisitReason: this.formData.closeReturnTripReason,
                revisitNotes: this.formData.closeNotes,
                justComplete: false,
                loadAttachData: this.formData.loadAttachData,
                collectPayment: this.formData.collectPayment,
                bypassAttach: this.formData.bypassAttach,
                tempCloseExcludeForInvoice: tempCloseExcludeForInvoice,
              });
            }
          }
        });
      }
    }
  }

  cancelClicked() {
    if (this.smDataService.isReadyToCompleteSelected) {
      this.smDataService.allShow = true;
      this.smDataService.currentWorkOrder.showScope = false;
      this.smDataService.currentWorkOrder = null;
      this.smDataService.isReadyToCompleteSelected = false;
    }
    this.ngbActiveModal.dismiss();
  }
}
